import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/(pages)/privacy-policy/Privacy_policy.jsx");
